import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    Output, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import {ConstantProperty} from '../../../_models/constant-property';
import {ColumnFormats} from "../../../services/table-utils.service";
import {ConstantField, isInvalid, InvalidField, isConstant, ConstantValue} from "../../../_models/api/generic-constant";
import {ConstantFieldComponent} from "../../constant-field/constant-field.component";
import {MatTooltip} from "@angular/material/tooltip";
import {UserService} from '../../../services/user.service';


@Component({
    selector: 'generic-constant-field',
    templateUrl: './generic-constant-field.component.html',
    styleUrls: ['./generic-constant-field.component.less'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    ConstantFieldComponent,
    MatTooltip
],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class GenericConstantFieldComponent implements OnInit {
    private _constant: ConstantField | InvalidField;
    @Input() set constant(constant: ConstantField | InvalidField) {
        this._constant = constant;
        if (constant) {
            this.setConstantAttributes();
        }
        this.changeDetectorRef.markForCheck();
    }

    get constant(): ConstantField | InvalidField {
        return this._constant;
    }

    @Input() constant_property: ConstantProperty;
    @Input() disabled: boolean;
    @Input() is_focussed: boolean;
    @Input() auto_class: string;
    @Input() tooltip: string;
    @Input() formats: ColumnFormats;
    @Input() defaultValue: ConstantValue = null;
    /**This (conditional_formats) is necessary because text-decoration can not be inherited from non text elements (e.g. div/td)**/
    @Input() conditional_formats: any;
    @Input() show_sig: boolean = true;
    @Input() placeholder: string = '';
    @Input() allow_fit: boolean;
    @Output() constant_changed: EventEmitter<any> = new EventEmitter();
    @Output() change_complete: EventEmitter<any> = new EventEmitter();
    @Output() lock_clicked: EventEmitter<void> = new EventEmitter();

    isConstant = isConstant;
    locked: boolean;
    invalid: boolean;
    public can_unlock = false;

    /**
     * A locked constant is never editable. Derived rather than latched onto the disabled input,
     * because every call site binds constant before disabled and the later write would win.
     */
    get isDisabled(): boolean {
        return Boolean(this.disabled || this.locked);
    }

    constructor(private changeDetectorRef: ChangeDetectorRef, private userService: UserService) {
    }

    ngOnInit(): void {
        this.can_unlock = this.userService.canUnlockData();
    }

    setConstantAttributes(): void {
        if (isInvalid(this.constant)) {
            this.invalid = true;
            return;
        }
        this.isLocked();
    }

    isLocked(): void {
        if (!isConstant(this.constant)) return;
        this.locked = this.constant.locked;
    }

    constantChanged(event): void {
        if (!isConstant(this.constant)) return; //Type check
        this.constant.value = event;
        this.constant_changed.emit(this.constant.value);
    }

    changeComplete(event?): void {
        if (!isConstant(this.constant)) return; //Type check
        this.change_complete.emit(this.constant.value);
    }

    constantChangedComplete(event): void {
        /*  Input event emitted when change is complete does not contain the value so using a separate function for
            datetime-picker and mat-select which emits the completed changed value in this case
        */
        this.constantChanged(event);
        this.changeComplete(event);
    }

    stringValue(value: ConstantValue): string {
        return String(value)
    }

    lockClicked(): void {
        if (this.can_unlock) {
            this.lock_clicked.next();
        }
    }
}
